import React, { ComponentType } from 'react';

import { ClassName, cn, Text } from 'Modules/ui';
import { ModalComponentProps } from 'Modules/core/messaging';

import styles from './index.module.scss';


export const coModalClassNames = {
    modal: styles.modal,
    standardSizeModal: styles.standardSizeModal,
    title: styles.title,
    buttons: styles.buttons,
};

export const getCoModal = (
    component: ModalComponentProps['component'],
    modalComponentProps: Omit<ModalComponentProps, 'component'> = {},
): ModalComponentProps => ({
    component,
    vPosition: 'centerTop',
    ...modalComponentProps,
});

export type CoModalProps = ClassName & {
    title?: string;
    standard?: boolean;
}

export const COModal: ComponentType<CoModalProps> = ({
    title,
    standard = false,
    className,
    children,
}) => (
    <div className={cn(
        styles.modal,
        standard && styles.standardSizeModal,
        className,
    )}
    >
        {title && (
            <Text
                className={coModalClassNames.title}
                component='div'
                textType='bold'
            >
                {title}
            </Text>
        )}
        {children}
    </div>
);
